module.exports = __webpack_public_path__ + "static/img/Home@2x.f643bd5.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/images/UI_mock/2x/Home@2x.png
// module id = oh6l
// module chunks = 1